import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '@directives/directives.module';
import { ButtonModule } from '@components/button';
import { NPSBannerComponent } from './n-p-s-banner.component';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    ButtonModule,
  ],
  declarations: [NPSBannerComponent],
  exports: [NPSBannerComponent],
})
export class NPSBannerModule {}
